// extracted by mini-css-extract-plugin
export default {"menuPaper":"pV8AaRzjpzsl62qzr+mnJQ==","menuItem":"WgEsPqiNtW1XRiqjeRLPmg==","menuItemSubtitle":"VyueRAoY10clmxq-cKCdVg==","iconButton":"DMT+ag1aWNu6kMrDl2lhhw=="};